<template>
     <div id="tablePrint">
        <b-table
            show-empty
            responsive
            :items="service"
            :fields="fields"
            :per-page="search.perPage"
            :busy="addService.isLoadTable"
            class="scroll-bar-pop text-center"
            empty-text="คุณยังไม่มีรายการบริการเสริม กรุณาเพิ่มรายการของคุณ"
            empty-filtered-text="ไม่พบข้อมูลที่ต้องการค้นหา"
        >
            <div slot="table-busy" class="text-center">
                <div class="text-center text-primary my-2">
                    <i class="fas fa-circle-notch fa-spin"></i>
                    <strong> Loading...</strong>
                </div>
            </div>
            <template slot="index" slot-scope="data">{{ getOverAllIndex( data.index ) }}</template>
            <template slot="serviceFee" slot-scope="data">{{data.item.serviceFee | numFormat('0,0.00')}}</template>
            <template slot="manage" slot-scope="data">
                <b-button
                    size="sm"
                    variant="info"
                    class="px-3"
                    @click="openModalEditService( data.item )"
                >
                    <i class="fas fa-circle-notch fa-spin" v-if="addService.serviceId == data.item.id"></i>
                    <i class="fas fa-pen" v-else></i> แก้ไข
                </b-button>
                <b-button
                    size="sm"
                    variant="danger"
                    class="px-3"
                    @click="openModalDeleteService( data.item )"
                >
                    <i class="fas fa-trash-alt"></i> ลบ
                </b-button>
            </template>
        </b-table>
        <div class="mt-3">
            <b-pagination
                :total-rows="search.totalItem"
                :current-page="search.page"
                :per-page="search.perPage"
                :value="search.page"
                @input="changePage"
                align="right">
            </b-pagination>
        </div>
        <ModalConfirm
            ref="confirmDelete"
            :confirm="confirm"
            @confirmModal="checkConfirmModal()"
        />
    </div>
</template>

<script>
import ModalConfirm from '@/components/Modals//ModalConfirm'
import { getServiceDetail , deleteService } from "@/axios/service.js";
import { showSuccessModal , showErrorModal } from "@/components/modalNotification.js";
import {deleteAdditionalService} from "@/api/additionalServices";

export default {
    props:{
        search: Object,
        service: Array,
        addService: Object,
    },
    components:{
        ModalConfirm
    },
    data(){
        return{
            confirm: {
                show: false,
                icon: "",
                emphasize: "",
                text: "",
                isLoad: false
            }
        }
    },
    methods:{
        getOverAllIndex(index){
            return ( this.search.page * 25 ) - 25 + index + 1
        },
        changePage(i){
            if (this.search.page == i) return;
            this.search.page = i
            this.$emit('getApiServiceDetails');
        },
        openModalEditService( row ){
            // this.addService.serviceId = id
            // getServiceDetail( this.addService ).then( res => {
                this.addService.name = row.serviceName;
                this.addService.categoryId = row.categoryId;
                this.addService.categoryName = row.categoryName;
                console.log(this.addService.categoryName)
                this.addService.categoryIdDefault = row.categoryId;
                this.addService.id = row.id
                this.addService.image.file = row.icon
                this.addService.fee = row.serviceFee
                this.addService.show = true
            // }).catch( error => {
            //     showErrorModal(error)
            // });
        },
        openModalDeleteService( item ){
            this.confirm.show = true
            this.confirm.icon = '<i class="fas fa-trash-alt text-red fa-2x"></i>'
            this.confirm.emphasize = `ลบ ${item.serviceName}`
            this.confirm.text = 'บริการเสริมนี้จะถูกลบออกจากระบบ คุณต้องการที่จะลบหรือไม่'
            this.addService.serviceId = item.id
        },
        checkConfirmModal(){
            this.confirm.isLoad = true;
            deleteAdditionalService(this.addService.serviceId).then( () => {
                this.addService.serviceId = null
                this.$refs.confirmDelete.closeModalConfirm();
                showSuccessModal('ลบข้อมูลสำเร็จ')
                this.$emit('getApiServiceDetails');
            }).catch( error => {
                showErrorModal(error)
                this.confirm.isLoad = false
            });
        }
    },
    computed:{
        fields(){
            let fields = [
                { key: "index", label: "ลำดับ", sortable: true },
                { key: "categoryName", label: "ชื่อหมวดหมู่", sortable: true },
                { key: "serviceName", label: "ชื่อบริการเสริม", sortable: true },
                { key: "serviceFee", label: "ค่าบริการ", sortable: true },
                { key: "updateTime", label: "วันที่สร้าง", sortable: true },
                { key: "manage", label: "จัดการ" }
            ]
            return fields
        }
    }
}
</script>
